/* eslint-disable jsx-a11y/label-has-associated-control */
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import copy from 'copy-to-clipboard';
import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../components/DataNotFound';
import SearchFilters from '../../../../components/elements/SearchFilter';
import Userbanner from '../../../../components/elements/Userbanner';
import { getFromLocalStorage } from '../../../../components/helper/authorizationHelper';
import { getAsync, postAsync, reactURL } from '../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../components/helper/downloadCSVHelper';
import './serviceDeadList.scss';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import { PageHitCountApi } from '../../../../shared/Helper';
import { useLocation } from 'react-use';
import { printTable } from '../../../../utils/tableExportUtils';
const ServiceForDeadList = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [dateFrom, setDateFrom] = useState('');
  const [selectedReason, setSelectedReason] = useState(null);
  const [dateTo, setDateTo] = useState('');
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [epUserID, setEpUserID] = useState(null);
  const [next, setNext] = useState(1);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const token = localStorage.getItem('token');

  const isLogin = () => {
    if (!token && !epUserID) {
      window.location.href = '/donorLogin';
    }
  };

  const handleCopy = async (e, id,projectTypeIdInt) => {
    e.preventDefault();
    try {
      await getAsync('ServiceDead/GetSDByIDAsync/', { id: id }).then((response) => {
        const result = response?.data[0];

        const sdReferralLink = `${reactURL}/PaymentProcess/${result?.projectID}/${result.referralLink}/${4}/${projectTypeIdInt}`;
        copy(sdReferralLink);
      });
    } catch (error) {
      console.error('msg_errorDueTo', error);
    }
    toast.success(t('Link copy Successfully'));
  };

  const openModal = (e, serviceDeadID) => {
    e.preventDefault();
    const selectedReason = apiData.find((data) => data.serviceDeadID === serviceDeadID)?.reason;
    setSelectedReason(selectedReason);
    setGridModalOpen(true);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setGridModalOpen(false);
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
  }, []);

  const handleRoute = (id) => {
    const link = '/ServiceForDeadView';
    navigate(link, { state: { id: id } });
  };

  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;

    return (
      <Table.Row items={apiData} key={`${data?.newProjectName}-${index}`}>
        <Table.Cell className="whitespace-nowrap">{sno}</Table.Cell>
        {/* <Table.Cell className="whitespace-nowrap">{data?.selectProjectTypeName || 'N/A'}</Table.Cell> */}
        <Table.Cell className="whitespace-nowrap">{data?.newProjectName || 'N/A'}</Table.Cell>
        {/* <Table.Cell className="whitespace-nowrap"> {data?.countryName || 'N/A'}</Table.Cell> */}
        <Table.Cell className="whitespace-nowrap"> {data?.date}</Table.Cell>
        <Table.Cell className="whitespace-nowrap">
          {t(`${data.maApproveID === 1 ? 'Approved' : data.maApproveID === 2 ? 'Disapproved' : 'Pending'}`)}
        </Table.Cell>
        <Table.Cell className="whitespace-nowrap">
          {/* Modal Create */}
          <>
            <button
              className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
              onClick={(e) => openModal(e, data?.serviceDeadID)}
            >
              {t('')} <VisibilityOutlinedIcon />
            </button>
          </>
          {/* end */}
        </Table.Cell>
        <Table.Cell className="whitespace-nowrap">
          <button
            onClick={() => handleRoute(data?.serviceDeadID)}
            className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
          >
            {t('')}
            <VisibilityOutlinedIcon />
          </button>
        </Table.Cell>
        <Table.Cell className="whitespace-nowrap">
          {data?.maApproveID == 1 && data?.publishID == 1 ? (
            <button
              className="text-customgreen hover:text-white border-2 border-customgreen hover:bg-hovergreen  focus:outline-none focus:ring-customgreen font-medium rounded-full text-sm px-3 py-2 text-center "
              onClick={(e) => handleCopy(e, data?.serviceDeadID,data?.projectTypeIdInt)}
            >
              <LinkOutlinedIcon />
              {t('Get Link')}
            </button>
          ) : null}
        </Table.Cell>
      </Table.Row>
    );
  });

  const bodyGet = {
    epUserID: epUserID,
  };

  const DateFilters = {
    epUserID: epUserID,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
  };

  const getPaginationList = async () => {
    setIsLoad(true);
    setDatanotfound(false);
    await postAsync(
      'ServiceDead/GetSDFilterListByUserID/' + pageOptions.pageNo + '/' + pageOptions.pageSize,
      DateFilters,
    )
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

    isLogin();
    if (epUserID !== null) {
      getData();
      PageHitCountApi(pathname, epUserID);
    }
  }, [epUserID]);

  const getData = () => {
    setIsLoad(true);
    postAsync('ServiceDead/GetSDFilterListByUserID/' + pageOptions.pageNo + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(pageOptions.pageNo);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const changePage = async ({ selected }) => {
    const select = selected + 1;
    await postAsync('ServiceDead/GetSDFilterListByUserID/' + select + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setApiData(response?.data);
        setPageCount(response.page);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    await getPaginationList();
  };

  // Export xlsl file
  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      [t('S.No')]: ii + 1,
      [t('Project Name')]: item.newProjectName,
      [t('Date')]: item.date,
     [t('Status')] : item.maApproveID === 1 ? t('Approved') : item.maApproveID === 2 ? t('Disapproved') : t('Pending'),
    }));
    downloadCSV(filteredData, 'Service Dead List');
  };
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('Project Name'),
      accessor: (row) => isActive ? row?.newProjectName  || 'N/A' : row?.newProjectName  || 'N/A'
    },
  
    {
      header: t('Date'),
      accessor: (row) => row?.date || 'N/A'
    },
    {
  header: t('Status'),
  accessor: (row) =>
    row?.maApproveID === 1
      ? t('Approved')
      : row?.maApproveID === 2
      ? t('Disapproved')
      : t('Pending') || 'N/A'
}

  ];
  
  // Call the reusable print function
  printTable({
    data: apiData || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Service For Dead')} ${t('list')}`,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
  // const handlePrint = (e) => {
  //   e.preventDefault();
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Service For Dead')} ${t('list')}`;
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">

  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Project Name`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Date`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Status`)}</th>
  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.newProjectName || 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.date || 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data.maApproveID === 1 ? t('Approved') : data.maApproveID === 2 ? t('Disapproved') : t('Pending')}</td>
  //           </tr>
  //         `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS to hide everything except the table when printing
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }
  //     .tableData {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 100%;
  //       height: auto;
  //       overflow: visible;
  //     }
  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog
  //   window.print();

  //   // Clean up by removing the table container and style from the DOM
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };

  return (
    <div className="pt-12 py-5 lg:py-10">
      {!isLogin ? (
        <h1>NOT AUTHORIZED</h1>
      ) : (
        <>
          <Userbanner />
          {isLoad ? (
            <LoadingAnimation
              imageStyling={''}
              styling={'flex items-center py-5 align-middle justify-center space-x-2'}
            />
          ) : (
            <div className="container-fluid pb-5 lg:pb-10  ">
              <div className="row text-center justify-center">
                <div className="col-lg-11 ">
                  <div className="flex justify-end   my-4">
                    <Link className="items-center md:items-end" to="/CreateServiceForDead">
                      <button className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center">
                        {t('create')}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              {/* Reason View Modal */}
              <MDBModal show={gridModalOpen} onHide={() => setGridModalOpen(false)}>
                <MDBModalDialog>
                  <MDBModalContent className="bg-green-50">
                    {/* Move the Form component outside the ModalHeader */}
                    <Form>
                      <MDBModalHeader className="text-customgreen font-semibold flex justify-center items-center">
                        <MDBModalTitle>{t('Reason')}</MDBModalTitle>
                        {/* <MDBBtn type="button" className="btn-close" color="none" onClick={closeModal}></MDBBtn> */}
                      </MDBModalHeader>
                      <MDBModalBody>
                        <div style={{ minHeight: 200 }} className="container-fluid bd-example-row">
                          {selectedReason}
                        </div>
                      </MDBModalBody>
                      <MDBModalFooter>
                        <button
                          className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-4 py-2 text-center"
                          onClick={closeModal}
                        >
                          {t('close')}
                        </button>
                      </MDBModalFooter>
                    </Form>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
              {/* Reason View Modal End*/}
              <div className="row  justify-center">
                <SearchFilters
                  handleSearch={handleSearch}
                  setDateFrom={setDateFrom}
                  setDateTo={setDateTo}
                  dateTo={dateTo}
                  dateFrom={dateFrom}
                  handlePrint={handlePrint}
                  handleOnExport={handleOnExport}
                  heading={'Service For Dead List'}
                />
                <div className="col-lg-11 pt-9">
                  <>
                    <div className="relative overflow-x-auto  shadow-md sm:rounded-lg">
                      <Table className="text-sm  tableData text-left rtl:text-right ">
                        <Table.Header className="text-sm font-bold text-white bg-customgreen uppercase">
                          <Table.Row>
                            <Table.HeaderCell className="text-white whitespace-nowrap">{t('sNo')}</Table.HeaderCell>
                            {/* <Table.HeaderCell className="text-white whitespace-nowrap">
                              {t('Project Type')}
                            </Table.HeaderCell> */}
                            <Table.HeaderCell className="text-white whitespace-nowrap">
                              {t('Project Name')}
                            </Table.HeaderCell>
                            {/* <Table.HeaderCell className="text-white whitespace-nowrap">{t('Country')}</Table.HeaderCell> */}
                            <Table.HeaderCell className="text-white whitespace-nowrap">{t('Date')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white whitespace-nowrap">{t('Status')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white whitespace-nowrap">{t('Reason')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white whitespace-nowrap">{t('Detail')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white whitespace-nowrap">
                              {t('Copy Link')}
                            </Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>{displayRecords}</Table.Body>
                      </Table>
                      {datanotfound && <DataNotFound />}
                    </div>
                    {pageCount > 0 && (
                      <div className="flex flex-row px-12 justify-between">
                        <Menu floated="right" pagination>
                          <Menu.Item>
                            <ReactPaginate
                              previousLabel={t('Previous')}
                              nextLabel={t('Next')}
                              pageCount={pageCount}
                              onPageChange={changePage}
                              containerClassName={'paginationButtons'}
                              previousLinkClassName={'previousButton'}
                              nextLinkClassName={'nextButton'}
                              disabledClassName={'paginationDisabled'}
                              activeClassName={'paginationActive'}
                            />
                          </Menu.Item>
                        </Menu>
                      </div>
                    )}
                  </>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ServiceForDeadList;
